import { useState } from 'react'
import api from '@/services/api/cdi.js'

const useCDI = () => {

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function push(id, payload, version) {

		const [error, data] = await api.push(id, payload, undefined, version)

		if (error) {
			throw error
		}

		return data
	}

	async function pull(id, payload, version) {

		const [error, data] = await api.pull(id, payload, undefined, version)

		if (error) {
			throw error
		}

		return data
	}

	return {
		error,
		loading,
		push,
		pull,
	}

}

export default useCDI
